<mat-card
  appearance="outlined"
  class="route-grid-card-item m6-forecast-card custom-m6-glass-card">
  <mat-card-content class="m6-forecast-body-grid-layout">
    @let imageUrlValue = imageUrl();
    @if (imageUrlValue) {
      <div class="m6-forecast-media-column-zone">
        <div class="m6-image-frame-glow">
          <img
            src="{{ imageUrlValue }}"
            alt="M6 Forecast Trends Map"
            class="m6-native-responsive-img" />
        </div>
      </div>
    }

    @let textValue = text();
    <div
      class="m6-forecast-text-column-zone"
      [class.full-width-text-fallback]="!imageUrlValue">
      @let dateValue = date();

      @if (textValue) {
        @let idValue = id();

        <!-- Dynamische Überschrift (Entweder Trend-ID oder formatiertes UTC-Datum) -->
        <div class="m6-headline-header-bar">
          @if (idValue) {
            <h3 class="m6-main-headline">
              <fa-icon
                [icon]="['far', 'analytics']"
                class="m6-header-icon"></fa-icon>
              {{ 'PRODUCT.M6.TREND.TREND_TEXT_HEADING_' + idValue | translate }}
            </h3>
          } @else if (dateValue) {
            <h3 class="m6-main-headline">
              <fa-icon
                [icon]="['far', 'clock']"
                class="m6-header-icon"></fa-icon>
              {{
                dateValue
                  | date
                    : 'dd.MM.yy – HH:mm'
                    : '+0000'
                    : (languageService.langSignal() | getLocaleFromLang)
              }}
              <small class="utc-label-string">UTC</small>
            </h3>
          }
          <mat-divider class="m6-title-divider"></mat-divider>
        </div>

        <div class="m6-payload-text-paragraphs">
          @for (paragraph of textValue.split('\n'); track $index) {
            <p class="m6-synopsis-line">
              {{ paragraph }}
            </p>
          }
        </div>
      } @else {
        <div class="m6-no-text-fallback-container">
          <div class="fallback-icon-avatar">
            <fa-icon
              [icon]="['far', 'pen-to-square']"
              size="2x"
              class="pen-icon-glow"></fa-icon>
          </div>
          <p class="fallback-text">
            {{ 'PRODUCT.M6.NO_TEXT' | translate }}
          </p>
        </div>
      }
    </div>
  </mat-card-content>
</mat-card>
